export default {
    changePassword: 'パスワードを変更',
    currentPassword: '元のパスワード',
    newPassword: '新しいパスワード',
    newPasswordConfirmation: '新しいパスワード(確認用)',
    passwordMismatch: 'パスワードが一致しません',
    title: 'パスワードの変更',
};
